package essntl.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.uikit.currentPlatform
import com.essntl.uikit.theme.esColorScheme
import core.config.buildFlavor

@Composable
fun EnvBanner(isConnected: Boolean?) {
    if ((isConnected == null || !isConnected) && !currentPlatform.isWeb) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(MaterialTheme.esColorScheme.primary.copy(alpha = 0.6f))
                .padding(
                    vertical = 8.dp,
                    horizontal = 20.dp,
                ),
        ) {
            Text(
                text = if (isConnected == null) "Verification..." else
                    "You're offline, Please check your internet connection",
                textAlign = TextAlign.Center,
                color = MaterialTheme.esColorScheme.textContrast,
                modifier = Modifier
                    .fillMaxWidth()
                    .align(Alignment.CenterVertically),
            )
        }
    } else if (buildFlavor.isStaging) {
        Row(
            modifier =
            Modifier
                .fillMaxWidth()
                .background(MaterialTheme.esColorScheme.borderError)
                .padding(
                    vertical = 8.dp,
                    horizontal = 20.dp,
                ),
        ) {
            Text(
                text = "Staging",
                color = MaterialTheme.esColorScheme.textContrast,
            )

            Spacer(modifier = Modifier.weight(1f))

            Text(
                text = "You're using staging data.",
                color = MaterialTheme.esColorScheme.textContrast,
            )

            Spacer(modifier = Modifier.weight(1f))
        }
    } else if (buildFlavor.isDemo) {
        Row(
            modifier =
            Modifier
                .fillMaxWidth()
                .background(MaterialTheme.esColorScheme.iconWarning)
                .padding(
                    vertical = 8.dp,
                    horizontal = 20.dp,
                ),
        ) {
            Text(
                text = "Demo",
                color = MaterialTheme.esColorScheme.textContrast,
            )

            Spacer(modifier = Modifier.weight(1f))

            Text(
                text = "You're using a demo account, data will be reset after 1 week.",
                color = MaterialTheme.esColorScheme.textContrast,
            )

            Spacer(modifier = Modifier.weight(1f))
        }
    } else if (buildFlavor.isLocal || buildFlavor.isDev) {
        Row(
            modifier =
            Modifier
                .fillMaxWidth()
                .background(MaterialTheme.esColorScheme.bgSuccess)
                .padding(
                    vertical = 8.dp,
                    horizontal = 20.dp,
                ),
        ) {
            Text(
                text = "Test",
                color = MaterialTheme.esColorScheme.textContrast,
            )

            Spacer(modifier = Modifier.weight(1f))

            Text(
                text = "You are using test data.",
                color = MaterialTheme.esColorScheme.textContrast,
            )

            Spacer(modifier = Modifier.weight(1f))
        }
    }
}
